// extracted by mini-css-extract-plugin
module.exports = {"cell":"RelativeDateCell-cell-2v-ql TableRowCell-cell-2fbg4"};